/**
 * Chuẩn hóa chuỗi tiếng Việt về dạng NFC (precomposed).
 *
 * Nội dung nhập từ macOS/iOS hoặc một số CMS thường ở dạng NFD (decomposed):
 * ví dụ "ậ" được lưu thành "a" + dấu mũ rời (U+0302) + dấu nặng rời (U+0323).
 * Các dấu kết hợp rời này không nằm trong subset web-font (latin/vietnamese)
 * nên iOS Safari fallback sang font hệ thống -> chữ bị lệch font.
 * Đưa về NFC ("ậ" = U+1EAD, một code point duy nhất) thì web-font render đúng.
 */
export const toNFC = (text?: string | null) => (text ?? "").normalize("NFC")

export const convertHtmlToArray = (html?: string) => {
  html = toNFC(html)

  if (!html) return null

  // Tách các thẻ <p> và lấy nội dung bên trong
  const pTagRegex = /<p[^>]*>(.*?)<\/p>/gs
  const matches = Array.from(html.matchAll(pTagRegex))

  const arr = matches
    .map(match => {
      let content = match[1]

      // Loại bỏ các thẻ <span> với style inline (chỉ dùng để styling)
      content = content.replace(/<span[^>]*>/gi, "")
      content = content.replace(/<\/span>/gi, "")

      // Giữ lại các thẻ định dạng semantic như <strong>, <em>, <b>, <i>, <u>
      // Các thẻ này sẽ được render bởi dangerouslySetInnerHTML

      // Xử lý HTML entities
      content = content
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&nbsp;/g, " ")

      return content.trim()
    })
    .filter(item => item !== "")

  return arr.length > 0 ? arr : null
}

export const parseElevation = (elevation?: string) => {
  if (!elevation || (elevation && elevation.trim() === "")) return ""

  // Regex để tìm các elevation values (có thể có dấu +/-, số với dấu phẩy, và đơn vị M)
  const elevationRegex = /[+-]?\s*\d{1,3}(?:,\d{3})*\s*M/g
  const matches = elevation.match(elevationRegex)

  if (matches) {
    // Clean up và format lại thành HTML
    return matches
      .map(match => match.trim())
      .filter(match => match !== "")
      .slice(0, 2)
      .map(elevation => `<p>${elevation}</p>`)
      .join("")
  }

  // Fallback: nếu regex không match, dùng cách cũ
  const parts = elevation
    .split(/(?<=\d{3}M)\s*,\s*(?=[+-])/) // Split chỉ khi có pattern "sốM, +" hoặc "sốM, -"
    .map(item => item.trim())
    .filter(item => item !== "")

  return parts
    .slice(0, 2)
    .map(elevation => `<p>${elevation}</p>`)
    .join("")
}
